<template>
	<div class="ordering" :class="{'menu-collapsed': isMenuCollapsed}" >
		<div class="heading">手机订单管理</div>
		<div class="content-view">
			<div class="rebutton">
				<el-badge :value="dingdan" :max="99" class="item" type="warning">
				  <el-button size="small" @click="refresh_order()">刷新订单</el-button>
				</el-badge>
			</div>
			<!-- 是否有数据 -->
			<div class="list">
				<div class="itemlist">
					<div class="butitemlist"  v-for="(item,index) in waitablist" :key="index">
						<el-button size="small" type="success" disabled v-if="!table_numbers.includes(item)">{{item}}</el-button>
						<el-button size="small" type="danger" v-if="table_numbers.includes(item)" :loading="index == check_load ? true : false" @click="checkout(item)">{{item}}<br>待结账</el-button>
					</div>
				</div>
				<div class="itemlist">
					<div  v-for="(item,index) in ertablist" :key="index">
						<el-button size="small" type="success" disabled v-if="!table_numbers.includes(item)">{{item}}</el-button>
						<el-button size="small" type="danger" v-if="table_numbers.includes(item)" :loading="index == check_load ? true : false" @click="checkout(item)">{{item}}<br>待结账</el-button>
					</div>
				</div>
				<div class="itemlist">
					<div  v-for="(item,index) in theretablist" :key="index">
						<el-button size="small" type="success" disabled v-if="!table_numbers.includes(item)">{{item}}</el-button>
						<el-button size="small" type="danger" v-if="table_numbers.includes(item)" :loading="index == check_load ? true : false" @click="checkout(item)">{{item}}<br>待结账</el-button>
					</div>
				</div>
				<div class="itemlist">
					<div  v-for="(item,index) in fourtablist" :key="index">
						<el-button size="small" type="success" disabled v-if="!table_numbers.includes(item)">{{item}}</el-button>
						<el-button size="small" type="danger" v-if="table_numbers.includes(item)" :loading="index == check_load ? true : false" @click="checkout(item)">{{item}}<br>待结账</el-button>
					</div>
				</div>
				<div class="itemlist">
					<div  v-for="(item,index) in baotablist" :key="index">
						<el-button size="small" type="success" disabled v-if="!table_numbers.includes(item)">{{item}}</el-button>
						<el-button size="small" type="danger" v-if="table_numbers.includes(item)" :loading="index == check_load ? true : false" @click="checkout(item)">{{item}}<br>待结账</el-button>
					</div>
				</div>				
			</div>
			<!-- 没有数据 -->
			<!-- <div class="nodatas" v-if="!nodatas">{{nodvalue}}</div> -->
		</div>
		<div style="height: 120px;"></div>
	</div>
</template>

<script>
// 交易状态
import {staff} from '../../../config/state-type.js'
// 价格补领
const Price = require('e-commerce_price')
export default{
	inject: ['isMenuCollapsed'],
	data() {
		return {
			Price:Price,
			options:staff(),
			loading: true,
			nodatas:true,
			dialogVisible:false,//弹出详细菜单
			deta_load:-1,//查看详细菜单
			rece_load:-1,//接单
			check_load:-1,//结账
			time:'',//交易时间
			statevalue:'',//交易状态
			nodvalue:'没有订单数据',
			total:0,//总条数
			pagenum:0,
			pickerOptions: {
			    disabledDate(time) {return time.getTime() > Date.now();}
			},
			tablist:['交易时间','桌号','用餐人数','菜单详情','交易金额(元)','交易状态'],
			waitablist:['Y1','Y2','Y3','Y4','Y5','Y6','Y7','Y8'],
			ertablist:['21','22','23','24','25','26','27','28'],
			theretablist:['31','32','33','34','35','36'],
			fourtablist:['41','42','43','44','45','46'],
			baotablist:['01','02','03','04','05','06','B1','B2'],
			tabcont:[],
			user_menu:[],//用户详细菜单
			dingdan:0,//订单提醒
			table_numbers:[],
			orderList:[],
			timer: null // 定时器ID
		}
	},
	methods:{
		// 获取订单
		async obtainorder(){
			try{
				let res = await new this.Request(this.Urls.m().obtainorderList + '?' + 'transac_status=unsettled').modeget()
				console.log(res)
				//获取到了待结账的桌号
				let table_numbers = [];
				this.orderList = res.data.data.result
				this.orderList.forEach(element => {
					table_numbers.push(element.table_number)
				});
				this.table_numbers = table_numbers
				this.dingdan = this.orderList.length;
			}catch(e){
				new this.mytitle(this.$message,'error','服务器发生错误,请重试').funtitle()
			}
		},

		// 结账
		async checkout(table_number){
			//this.check_load = index
			const order = this.orderList.find(item => item.table_number === table_number)
			if(!order){
				new this.mytitle(this.$message,'error','未找到匹配订单').funtitle();
				return;
			}
			let obj = this.$qs.stringify({id:order._id})
			try{
				let res = await new this.Request(this.Urls.m().checkout + '?' + obj).modeget()
				this.obtainorder()
				// console.log(res)
				// this.$set(this.tabcont[index],'transac_status','success')
				// new this.mytitle(this.$message,'success',res.data.msg).funtitle()
			}catch(e){
				console.log(e)
				new this.mytitle(this.$message,'error','服务器发生错误,请重试').funtitle()
			}
		},
		// 刷新订单
		refresh_order(){
			this.loading = true
			this.deta_load = -1,//查看详细菜单
			this.rece_load = -1,//接单
			this.check_load = -1,//结账
			this.obtainorder()
		},
		// 查询订单
		queryFun(){
			this.pagenum = 0
			this.obtainorder(0)
		}
	},
	created() {
		// 获取订单
		this.obtainorder()
		// 订单提醒
		this.dingdan = localStorage.getItem("order_num")
		// 设置定时器，每隔30秒刷新订单
		this.timer = setInterval(() => {
			console.log('刷新订单')
			this.obtainorder()
		}, 60000)
	},
	beforeDestroy() {
		// 清除定时器
		if (this.timer) {
			clearInterval(this.timer)
		}
	},
	watch: {
		// 监听订单提醒
		"$store.state.remind"(newValue, oldValue) {
			this.dingdan = newValue.num
		}
	},
}
</script>

<style scoped="scoped">
@import url("../../../style/pubiss.css");
@import url("../../../style/popup.css");
/* ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #00be06;
	color: #fff;
}
::v-deep .el-badge{
	margin-right: 5px;
}
.menu-padd{
	border-bottom: 1px solid #f8f8f8;
} */
.rebutton{
	margin-bottom: 15px;
}
.list {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
    gap: 10px;
    position: absolute;
    /* left: 20px; */
    /* top: 100px; */
}
.itemlist {
    height: 100%;
    width: 100% !important;
}


.itemlist .el-button {
    width: 58px !important;
    height: 50px;
    margin: 10px 0 !important;
	padding: 10px 5px ;
    white-space: nowrap;
    display: block !important;
	text-align: center;
	font-size: 15px;
}

.ordering {
  position: absolute;
  top: 50px;
  /* left: 5px; */
  /* right: 0; */
  padding: 20px 0;
  margin: 0 auto;
  max-width: 1400px;
  transition: left 0.3s;
}
.ordering.menu-collapsed {
  left: 20px;
}
@media (max-width: 768px) {
  .ordering.menu-collapsed {
    left: 50px !important;
    right: 0 !important;
    width: calc(100vw - 50px) !important;
    max-width: calc(100vw - 50px) !important;
  }
  .ordering, .ordering.menu-collapsed {
    left: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
  }
  .content-view {
    padding: 0 !important;
    margin: 0 !important;
  }
  .rebutton {
    margin-Top: 15px;
    margin-bottom: 15px;
    margin-left: 46px; /* 已添加：为刷新按钮容器添加左边距 */
  }
  .list {
    /* flex-direction: column !important; */
    gap: 0 !important;
    position: static !important;
    width: 100% !important;
    margin: 0 !important;
  }
  .itemlist {
    width: 18% !important;
    /* display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: flex-start !important; */
    margin-bottom: 8px;
    overflow-x: auto;
    /* padding-left: 10px; 已添加：给列表左侧添加一些内边距 */
  }
  .itemlist .el-button {
    flex: 1 0 0;
    min-width: 60px !important;
    max-width: 120px !important;
    /* height: 36px !important; */
    /* font-size: 13px !important; */
    margin: 5px 5px 10px 5px !important;
    padding: 5px 0 !important;
	/* font-weight: bold; */
    white-space: normal;
  }
}
</style>
